<template>
  <span>
    <span v-for="msg in obj">
      <span v-if="msg.type === 'text'">{{ msg.text }}</span>
      <span v-if="msg.type === 'br'"><br></span>
      <span v-if="msg.type === 'link'"><b-link @click="onPopover(msg.number)">{{msg.number}}番</b-link></span>
      <span v-if="msg.type === 'quote'">
        <b-link @click="onPopover(msg.number)" class="quotenumber">{{msg.number}}番</b-link>
        <blockquote><BoardMessageParts :obj="msg.children" /></blockquote>
      </span>
    </span>
  </span>
</template>
<script>
import BoardMessageParts from './BoardMessageParts';
export default {
  name: 'BoardMessageParts',
  components: { BoardMessageParts },
  props: ['obj'],
};
</script>
<style scoped>
.quotenumber {
  font-size: 0.8rem;
  font-style: italic;
  color: gray;
}
blockquote {
  margin: 0;
  padding: 0 0 0 1rem;
  border-left: 3px solid gray;
}
</style>
